export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "show-password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show password"])},
        "hide-password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hide password"])}
      },
      "fr": {
        "show-password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afficher le mot de passe"])},
        "hide-password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Masquer le mot de passe"])}
      }
    }
  })
}
